import { filterConsistencyParamDeclarations } from "app/routes/handlers/filter-consistency/filterConsistencyUtils";
import { BasicDurations } from "app/services/DurationService";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import type { PublisherAnalysisParamsDefinition } from "single-spa/react-app/config/solutions25/adIntelligence/publisherAnalysis/publisherAnalysisRoutes.types";

// See advertiser-activity/routing/constants — route objects live in the shared SI constants
// module; re-exported here for the co-located states/secondary-bar files.
export { SI_PA_ROUTES } from "app/common/constants/ad-intelligence-routes";

export const siPublisherAnalysisParams: PublisherAnalysisParamsDefinition = {
    key: {
        type: "string",
        dynamic: false,
    },
    duration: {
        type: "string",
        value: BasicDurations.LAST_TWENTY_EIGHT_DAYS,
    },
    webSource: {
        type: "string",
        value: devicesTypes.DESKTOP,
    },
    country: {
        type: "int",
        array: false,
        value: 840,
    },
    isWWW: {
        type: "string",
        value: "*",
    },
    adsViewType: {
        type: "int",
        array: false,
        value: 0,
    },
    pdf: {
        type: "bool",
        array: false,
        value: false,
    },
    ...filterConsistencyParamDeclarations,
} as const;
